import { useEffect } from 'react';
import { useApiContext } from 'react-easyrocket';

export const useCacheSession = () => {
  const { isAuthenticated } = useApiContext();
  useEffect(() => {
    if (!window.caches) return;
    if (!isAuthenticated) {
      caches.has('a').then((isUuId) => {
        if (isUuId) {
          caches.delete('a');
        }
      });
    } else {
      const token = localStorage.getItem('accessToken');
      if (token) {
        caches.open('a').then((cache) => cache.put('/get-uuid', new Response(btoa(token))));
      }
    }
  }, [isAuthenticated]);
};
